/** @jsxImportSource @emotion/react */

import styled from "@emotion/styled";
import { Link, useHistory } from "react-router-dom";
import { Screen, TextField } from "../components";
import { buttonStyle } from "../styles";

import * as colors from "../styles/colors";

import Logo from "../assets/images/xeron-logo.png";
import { useState } from "react";

function Landing() {
  return (
    <Screen>
      <div css={{ textAlign: "center" }}>
        <div>
          <img css={{ width: "10em" }} src={Logo} alt="xeron-care" />
        </div>
        <h1 css={{ color: colors.secondary }}>Xeron Care</h1>
        <h2 css={{ marginTop: "1em", fontWeight: 400 }}>
          SINGLE DATA PATIENT RECORD
        </h2>
        <div css={{ marginTop: "6em" }}>
          <Link
            to="/create-record"
            css={{
              ...landingButtonStyle,
              textDecoration: "none",
            }}
          >
            Create Record
          </Link>
          <Link
            to="/records"
            css={{
              ...landingButtonStyle,
              textDecoration: "none",
            }}
          >
            Retrieve Records
          </Link>
        </div>
        <div
          css={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Line />
          <div css={{ margin: "0 1em" }}>OR</div>
          <Line />
        </div>
        <RetrieveForm />
      </div>
    </Screen>
  );
}

function RetrieveForm() {
  const history = useHistory();
  const [address, setAddress] = useState("");

  const handleChange = (evt) => {
    const { value: addressEntered } = evt.target;
    setAddress(addressEntered);
  };

  const handleSubmit = (evt) => {
    evt.preventDefault();
    history.push(`/records/${address}`);
  };

  return (
    <form
      onSubmit={handleSubmit}
      css={{
        margin: "auto",
        display: "flex",
        alignItems: "center",
        gap: "1em",
      }}
    >
      <TextField
        id="retrieve-address"
        label="Retrieve by Address"
        placeholder="Enter address"
        maxLength={42}
        css={{ flex: "1" }}
        textFieldProps={{
          onChange: handleChange,
          value: address,
          style: { padding: "1em", paddingTop: "1.6em", fontSize: "0.79rem" },
        }}
      />
      <button
        css={{
          ...landingButtonStyle,
          width: "max-content",
          borderRadius: "0.3em",
          padding: "1em 2em",
          fontSize: "1rem"
        }}
      >
        Retrieve
      </button>
    </form>
  );
}

const Line = styled.div({
  width: "10em",
  backgroundColor: colors.white,
  height: "0.1em",
});

const landingButtonStyle = {
  ...buttonStyle,
  display: "block",
  margin: "3em auto",
  width: "21em",
  fontSize: "1.2em",
  fontWeight: 900,
  color: colors.white,
};

export default Landing;
